import { IconButton } from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";

const HelpButtonModal = ({ open, setOpen }) => {
 const handleClose = () => {
  setOpen(false);
 };

 return (
  <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose} sx={{}}>
   <DialogTitle
    sx={{
     display: "flex",
     flexDirection: "row",
     alignItems: "center",
     justifyContent: "flex-end",
     padding: "2px 2px 0px 0px",
     background: "var(--broward-blue)",
    }}
   >
    <IconButton
     aria-label="close"
     aria-haspopup="true"
     color="inherit"
     onClick={handleClose}
     sx={{ padding: "4px" }}
    >
     <CloseIcon sx={{ color: "white" }} fontSize="small" />
    </IconButton>
   </DialogTitle>
   <DialogContent
    sx={{
     border: "28px solid var(--broward-blue)",
     borderTop: "none",
     padding: "0px 0px !important",
    }}
   >
    <DialogContentText></DialogContentText>
    <Box
     sx={{
      display: "flex",
      flexDirection: "column",
      m: "auto",
      width: "fit-content",
     }}
    >
     <video controls width="100%">
      <source
       src="https://video.wixstatic.com/video/169f01_4158abd7655a423ebab24aa5e9b6576e/1080p/mp4/file.mp4"
       type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
     </video>
    </Box>
   </DialogContent>
  </Dialog>
 );
};

export default HelpButtonModal;
